import { encodeDocumentPath } from './document-links'

export const DASHBOARDS_ROOT = '/dashboards'
export const DASHBOARD_TEMPLATES_ROOT = '/dashboards/templates'

/** Stable Dashboards explorer route for a cited resource path. */
export function dashboardHref(path: string): string {
  const encoded = encodeDocumentPath(path)
  return encoded.length > 0 ? `${DASHBOARDS_ROOT}/${encoded}` : DASHBOARDS_ROOT
}

/** Stable Templates explorer route for a cited resource path. */
export function dashboardTemplateHref(path: string): string {
  const encoded = encodeDocumentPath(path)
  return encoded.length > 0 ? `${DASHBOARD_TEMPLATES_ROOT}/${encoded}` : DASHBOARD_TEMPLATES_ROOT
}
